import * as tslib_1 from "tslib";
import { ChangeDetectorRef, ElementRef, OnDestroy, } from '@angular/core';
import { FormBuilder, FormControl, Validators, } from '@angular/forms';
import { Router } from '@angular/router';
import { AppStateFacade } from '@app-state';
import { ClientAuthErrorCodes, } from '@models';
import { AuthService, ErrorMapperService, ServerConfiguration, StorageService, } from '@services';
import { UiSnackBarService } from '@uipath/angular/components/ui-snackbar';
import { extractCookies } from '@uipath/angular/utilities';
import { filterNullOrUndefined } from '@utils/rxjs.utils';
import UiValidators, { UI_EMAIL_MAX_LENGTH, UI_NAME_LONG_MAX_LENGTH, UI_PASSWORD_MAX_LENGTH, } from '@validators';
import { BehaviorSubject, Subject, } from 'rxjs';
import { map, takeUntil, } from 'rxjs/operators';
var LoginPageComponent = /** @class */ (function () {
    function LoginPageComponent(errorMapperService, fb, auth, _router, _cd, _snack, _serverConfig, _appState, _storage) {
        var _this = this;
        this.auth = auth;
        this._router = _router;
        this._cd = _cd;
        this._snack = _snack;
        this._serverConfig = _serverConfig;
        this._appState = _appState;
        this._storage = _storage;
        this.loading$ = new BehaviorSubject(false);
        this.isTenantFieldVisible = false;
        this.allowPasswordChange = true;
        this.isRememberMeEnabled = false;
        this._destroyed$ = new Subject();
        this.authConfig$ = this._appState.authConfig.value$;
        this.allowPasswordChange = !!this._appState.authConfig.value.cloud.allowPasswordChange;
        this.lastTenantName = auth.lastTenantUsed;
        this.form = fb.group({
            'tenancyName': [
                this.lastTenantName,
                Validators.maxLength(UI_NAME_LONG_MAX_LENGTH),
            ],
            'usernameOrEmailAddress': [
                '',
                Validators.compose([
                    Validators.required,
                    UiValidators.whitespace,
                    Validators.maxLength(UI_EMAIL_MAX_LENGTH),
                ]),
            ],
            'password': [
                '',
                Validators.compose([
                    Validators.required,
                    Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                ]),
            ],
        });
        if (this._appState.authConfig.value.isRememberMeEnabled) {
            this.isRememberMeEnabled = true;
            this.form.addControl('rememberMe', new FormControl(true));
        }
        var params = this._router.routerState.snapshot.root.queryParamMap;
        var ERROR_CODE_PARAM = 'errorCode';
        var paramErrorCode = Number(ClientAuthErrorCodes[params.get(ERROR_CODE_PARAM)]);
        if (!paramErrorCode) {
            return;
        }
        errorMapperService.auth
            .pipe(map(function (errorCodes) { return errorCodes[params.get(ERROR_CODE_PARAM)]; }), filterNullOrUndefined(), takeUntil(this._destroyed$))
            .subscribe(function (error) {
            _this._snack.error(error + " (#" + paramErrorCode + ")");
            _this._router.navigate(['/account/login'], { queryParams: { returnUrl: params.get('returnUrl') } });
        });
    }
    Object.defineProperty(LoginPageComponent.prototype, "externalUrl", {
        get: function () {
            return this._serverConfig.baseHref + "/Account/ExternalLogin";
        },
        enumerable: true,
        configurable: true
    });
    LoginPageComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
    };
    LoginPageComponent.prototype.switchTenant = function (event) {
        event.preventDefault();
        this.isTenantFieldVisible = true;
        this.form.get('tenancyName').setValue('');
    };
    LoginPageComponent.prototype.externalLogin = function (provider) {
        var _this = this;
        this.provider = provider;
        this._appState.user
            .ensureCorrectIdentity()
            .subscribe(function () {
            _this.xsrfToken = extractCookies()['XSRF-TOKEN'];
            _this._cd.detectChanges();
            _this._externalLoginForm.nativeElement.submit();
        });
    };
    LoginPageComponent.prototype.onSubmit = function (event) {
        var _this = this;
        event.preventDefault();
        if (!this.form.valid) {
            return;
        }
        this.loading$.next(true);
        this._appState.user.login(this.form.value)
            .subscribe(function (user) {
            // store the tenant value only if the login is successful
            _this.auth.lastTenantUsed = _this.form.value.tenancyName;
            _this._storage.set('loggedInUser', user.id.toString());
            var requestedRoute = _this._router.routerState.snapshot.root.queryParams['returnUrl'];
            var _a = _this.auth.extractReturnUrl(requestedRoute), returnUrl = _a.returnUrl, navigationParams = _a.navigationParams;
            _this._router.navigate([returnUrl], navigationParams);
        }, function (httpErrorResponse) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var errorResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading$.next(false);
                        if (httpErrorResponse.status === 0) {
                            return [2 /*return*/];
                        }
                        if (!(httpErrorResponse.status === 423)) return [3 /*break*/, 2];
                        this.auth.lastTenantUsed = this.form.value.tenancyName;
                        return [4 /*yield*/, this._appState.user.ensureCorrectIdentity().toPromise()];
                    case 1:
                        _a.sent();
                        errorResponse = httpErrorResponse.error;
                        this._router.navigate(['/account/passwordexpired'], {
                            queryParams: {
                                userId: errorResponse.result.userId,
                            },
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); });
    };
    return LoginPageComponent;
}());
export { LoginPageComponent };
